import React, {Component, useEffect, useState} from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import Deposits from './deposits/Deposits';
import Statements from './statements/Statements';
import Help from './help/Help';
import Header from "./header/Header";
import Footer from "./footer/Footer";
import InvoicePage from "./invoice/InvoicePage";
import PaymentPage from "./invoice/PaymentPage";
import PaymentStatusPage from "./invoice/PaymentStatusPage";
import DetailPage from "./invoice/DetailPage";
import InvoiceSearch from './invoice/InvoiceSearch';
import {connect} from 'react-redux';
import {getSelectedPrimaryAccount} from "./invoice/Selectors";
import PayerDetailsDataManager from "./invoice/PayerDetailsDataManager";
import {Redirect} from 'react-router-dom';
import {getUser} from "../actions/UserActions";
import SettingsPage from "./settings-page/SettingsPage";
import InvoiceDataManager from "./invoice/InvoiceDataManager";
import {canEditSystemConfig, canMakePayment} from "../PermissionSelectors";
import EditConfiguration from "./settings-page/configuration/EditConfiguration";
import BasePageErrorBoundary from "../error-boundaries/BasePageErrorBoundary";
import PaymentStatusErrorBoundary from "../error-boundaries/PaymentStatusErrorBoundary";

export function BasePage(props) {
  let [user, setUser] = useState(null);

  useEffect(() => {
    getUser(props.dispatch).then(user => {
      if (user) {
        if (props.sap.statusCode === 200 && props.sap.data.status.message_type === "S") {
          if (user && user.Status === "waiting-confirmation") {
            props.history.push("/auto-register/waiting-confirmation");
          } else {
            setUser(user);
          }
        } else {
          if (user.Permissions.indexOf("CanEditSystemConfig") > -1) {
            props.history.push("/settings/configuration");
          } else {
            props.history.replace("/system-error");
          }
        }
      }
    });
  }, []);

  return <React.Fragment>
    {(!props.isLoggedIn) ? <Redirect to={"/login"}/> :
      <React.Fragment>
        <Header/>
        {(user) ? <React.Fragment>
            <InvoiceDataManager render={
              (
                <PayerDetailsDataManager render={(
                  <div className={"app-content"}>
                    <Switch>
                      <Route path="/invoices">
                        <React.Fragment>
                          <Switch>
                            {props.canMakePayment && <Route path={"/invoices/pay"}
                                                            render={() => (
                                                              <BasePageErrorBoundary><PaymentPage/></BasePageErrorBoundary>)}/>}
                            {props.canMakePayment && <Route path={"/invoices/payment-status"}
                                                            render={() => (
                                                              <PaymentStatusErrorBoundary><PaymentStatusPage/></PaymentStatusErrorBoundary>)}/>}
                            <Route path={"/invoices/detail/:billingDocumentNumber"}
                                   render={() => (<BasePageErrorBoundary><DetailPage/></BasePageErrorBoundary>)}/>
                            <Route path={"/invoices/invoicesearch"}
                                   render={() => (<BasePageErrorBoundary><InvoiceSearch/></BasePageErrorBoundary>)}/>
                            <Route path={"/invoices"}
                                   render={() => (<BasePageErrorBoundary><InvoicePage/></BasePageErrorBoundary>)}/>
                          </Switch>
                        </React.Fragment>
                      </Route>
                      <Route path="/deposits"
                             render={() => (<BasePageErrorBoundary><Deposits/></BasePageErrorBoundary>)}/>
                      <Route path="/statements"
                             render={() => (<BasePageErrorBoundary><Statements/></BasePageErrorBoundary>)}/>
                      <Route path="/help"
                             render={() => (<BasePageErrorBoundary><Help/></BasePageErrorBoundary>)}/>
                      <Route path={"/settings"}
                             component={SettingsPage}/>
                      <Route path={"/system"}
                             render={() => (<BasePageErrorBoundary><SettingsPage/></BasePageErrorBoundary>)}/>
                      <Route path={"/"}
                             render={() => (<BasePageErrorBoundary><InvoicePage/></BasePageErrorBoundary>)}/>
                    </Switch>
                  </div>
                )}/>
              )
            }/>
          </React.Fragment> :
          <React.Fragment> {/* we want to still be able to get to system settings even if user doesn't have SAP accounts setup. */}
            <Switch>
              {props.canEditSystemConfig &&
              <Route path={"/settings/configuration"} render={props => (
                <div className={"settings-page"}>
                  <EditConfiguration/>

                </div>
              )
              }/>}
            </Switch>
          </React.Fragment>
        }
        <Footer/>
      </React.Fragment>
    }
  </React.Fragment>
}

export default withRouter(connect((state, props) => {
  return {
    selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
    isLoggedIn: state.user.isLoggedIn,
    canMakePayment: canMakePayment(state, props),
    currentUser: state.default.currentUser,
    sap: state.app.config.sap,
    canEditSystemConfig: canEditSystemConfig(state, props),
  }
})(BasePage));
